import { MultiLingualStylesheet } from '../interfaces/Stylesheet';
import { Ticket } from '../interfaces/Ticket';
import { SupportedErrorTypes } from '../services/ErrorService';

type ErrorConfig = {
  reason: SupportedErrorTypes;
  stylesheet?: MultiLingualStylesheet;
  ticket?: Ticket;
};
export class SelfServiceError extends Error {
  reason: SupportedErrorTypes;
  stylesheet?: MultiLingualStylesheet;
  ticket?: Ticket;

  constructor({ reason, ticket, stylesheet }: ErrorConfig) {
    super(reason);

    this.name = 'SelfServiceError';
    this.reason = reason;
    this.ticket = ticket;
    this.stylesheet = stylesheet;
  }
}

export const isSelfServiceError = (error: Error): error is SelfServiceError => {
  return error instanceof SelfServiceError;
};
